import { CustomListItemId } from "@sp-crm/core";
import { GetCustomListQuery } from "generated/graphql";

export type HomeCareStatusList = GetCustomListQuery["getCustomList"] | null;
export type HomeCareStatusListItem = NonNullable<HomeCareStatusList>["items"][number];

export type ClientStatusFilterMode = "activeLeads" | "currentClients";

export type ClientStatusFilterValue =
    | { mode: "activeLeads"; statusIds: CustomListItemId[] }
    | { mode: "currentClients" };

export const defaultClientStatusFilterValue: ClientStatusFilterValue = {
    mode: "currentClients",
};

const closedWonKey = "hcClosedWon";

export function activeCategoryItemIds(
    customList: HomeCareStatusList,
): CustomListItemId[] {
    if (!customList) {
        return [];
    }
    const activeCategoryIds = customList.categories
        .filter(category => category.key === "Active")
        .map(category => category.id);
    return customList.items
        .filter(
            item =>
                !item.isArchived && activeCategoryIds.includes(item.customListCategoryId),
        )
        .map(item => item.id);
}

export function closedWonItem(
    customList: HomeCareStatusList,
): HomeCareStatusListItem | null {
    return (
        customList?.items.find(item => item.key === closedWonKey && !item.isArchived) ??
        null
    );
}

export function statusListItemIdsForFilter(
    customList: HomeCareStatusList,
    value: ClientStatusFilterValue,
): CustomListItemId[] {
    if (value.mode === "currentClients") {
        const wonItem = closedWonItem(customList);
        return wonItem
            ? [...activeCategoryItemIds(customList), wonItem.id]
            : activeCategoryItemIds(customList);
    }
    return value.statusIds;
}

export function requireStartOfCareForFilter(value: ClientStatusFilterValue): boolean {
    return value.mode === "currentClients";
}
